angular.module('webtip.module').factory('alarmNotificationService', function (toasterService, $rootScope) {
  const notify = method => (...args) => {
    $rootScope.$evalAsync(() => toasterService[method](...args));
  };

  return {
    error: notify('error'),
    success: notify('success'),
    warning: notify('warning'),
  };
});